import React, { useEffect, useState } from "react";
import "./layout.css";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <header className="header z-10">
        <Header />
      </header>
      <div className="sidebar-main-wrapper">
        <aside>
          <Sidebar />
        </aside>
        <main className="main">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
